import type { ComponentType, HTMLAttributes, ReactNode } from 'react'

import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary'

export type PageProps = {
  children: ReactNode
}

export function Page({ children }: PageProps) {
  return <ErrorBoundary>{children}</ErrorBoundary>
}

export type SectionProps = HTMLAttributes<HTMLElement> & {
  children: ReactNode
}

export function Section({ children, ...props }: SectionProps) {
  return (
    <section {...props}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </section>
  )
}

export const Layout = {
  Page,
  Section,
}

export function withLayout<P extends object>(
  LayoutComponent: ComponentType<{ children: ReactNode }>,
  Component: ComponentType<P>
): ComponentType<P> {
  return function WrappedComponent(props: P) {
    return (
      <LayoutComponent>
        <Component {...props} />
      </LayoutComponent>
    )
  }
}
